import { ReactElement, useState, useEffect } from "react";
import { Paper } from "@material-ui/core";
import { ArrowLeftOutlined, ClockCircleOutlined, CalendarOutlined, FieldTimeOutlined, HomeOutlined, DollarOutlined, CarryOutOutlined, NotificationOutlined } from "@ant-design/icons";
import { Row, Col, Button, Input, Form } from "antd";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { getBookingState, getAuthState } from "../../redux/selectors";
import Checkout from "../../components/CheckoutModal";

export default function BookingConfirm(props: any): ReactElement {
  const { bookingDate, bookingTime, duration, loading, onComplete, onBack, court } = props;
  const { t } = useTranslation();
  const { preBranch } = useSelector(getBookingState);
  const { currentUser } = useSelector(getAuthState);
  const [additionalInfo, setAdditionalInfo] = useState<string>("");
  const [visibleCheckout, setVisibleCheckout] = useState<boolean>(false)

  const onPressConfirm = () => {
    if (preBranch?.clubData.payOverCount) {
      onComplete(additionalInfo, "pay_over_count")
    } else {
      // will need to add firebase store function first.
      // after it is done, we will need to complete the process for payment.
      setVisibleCheckout(true);
    }
  }

  const onDonePayment = (transactionId: string) => {
    onComplete(additionalInfo, "online", transactionId);
  }

  return (
    <Row gutter={16}>
      <Col xs={24} sm={24} md={preBranch?.clubData.payOverCount ? 24 : 16}>
        <Paper className="booking-card" style={{ marginLeft: 10 }}>
          <Row>
            <Col sm={24} md={24} className="booking-calendar-container">
              <h3 className="booking-header-title">{t("booking.confirm_your_booking")}</h3>
              <h4 style={{ marginBottom: 10 }}>
                <CalendarOutlined style={{ fontSize: 18 }} />
                <span className="booking-confirm-text">{t("booking.booking_date")}:</span>
                <span className="booking-confirm-text-no-margin float-right">{moment(`${bookingDate}`).format("MMMM D, ddd")}</span>
              </h4>
              <h4 style={{ marginBottom: 10 }}>
                <ClockCircleOutlined style={{ fontSize: 18 }} />
                <span className="booking-confirm-text">{t("booking.booking_time")}:</span>
                <span className="booking-confirm-text-no-margin float-right">
                  {moment(`${bookingDate} ${bookingTime}`).format("h:mm A")}
                </span>
              </h4>
              <h4 style={{ marginBottom: 10 }}>
                <FieldTimeOutlined style={{ fontSize: 18 }} />
                <span className="booking-confirm-text">{t("booking.booking_duration")}:</span>
                <span className="booking-confirm-text-no-margin float-right">
                  {duration} {t("mins")}
                </span>
              </h4>
              <h4 style={{ marginBottom: 10 }}>
                <HomeOutlined style={{ fontSize: 18 }} />
                <span className="booking-confirm-text">{t("club.club")}:</span>
                <span className="booking-confirm-text-no-margin float-right">
                  {preBranch?.clubData.name}
                </span>
              </h4>
              <h4 style={{ marginBottom: 10 }}>
                <HomeOutlined style={{ fontSize: 18 }} />
                <span className="booking-confirm-text">{t("branch.branch")}:</span>
                <span className="booking-confirm-text-no-margin float-right">
                  {preBranch?.location}
                </span>
              </h4>
              <h4 style={{ marginBottom: 10 }}>
                <HomeOutlined style={{ fontSize: 18 }} />
                <span className="booking-confirm-text">{t("court.court")}:</span>
                <span className="booking-confirm-text-no-margin float-right">
                  {court.name}
                </span>
              </h4>
              <h4 style={{ marginBottom: 10 }}>
                <DollarOutlined style={{ fontSize: 18 }} />
                <span className="booking-confirm-text">{t("price")}: </span>
                <span className="booking-confirm-text-no-margin float-right">
                  {preBranch?.clubData.price[duration]} {preBranch?.clubData.currency}
                </span>
                {preBranch?.clubData.payOverCount && <span style={{ marginLeft: 10, color: "grey", fontStyle: "italic", fontSize: 12 }}>{t("booking.pay_over_counter")}</span>}
              </h4>
              <div style={{ marginTop: 20 }}>
                <h4>
                  <NotificationOutlined style={{ fontSize: 18 }} />
                  <span className="booking-confirm-text">{t("booking.additional_information")}: </span>
                </h4>
                <Input.TextArea
                  rows={4}
                  placeholder={t("club.description_placeholder")}
                  style={{ marginTop: 5, borderRadius: 5, borderWidth: 2 }}
                  onChange={(event) => setAdditionalInfo(event.target.value)}
                />
              </div>
              {currentUser === undefined && <div style={{ marginTop: 10, textAlign: "center", color: "red" }}>
                <span> * {t("booking.not_login_alert")}</span>
              </div>}
              <div
                style={{
                  marginTop: 20,
                  marginBottom: 10,
                  width: "100%",
                  textAlign: "center",
                }}
              >
                {preBranch?.clubData.payOverCount &&
                  <Button type="primary" icon={<CarryOutOutlined />} style={{ marginTop: 10, width: 300, height: 40 }} onClick={onPressConfirm} loading={loading}>
                    {t("booking.book")}
                  </Button>
                }
                <Button type="primary" icon={<ArrowLeftOutlined />} style={{ marginTop: 10, width: 300, height: 40 }} onClick={onBack}>
                  {t("back")}
                </Button>
              </div>
            </Col>
          </Row>
        </Paper>
      </Col>
      {!preBranch?.clubData.payOverCount && <Col xs={24} sm={24} md={8}>
        <Paper className="booking-checkout-card">
          <Checkout
            visible={visibleCheckout}
            user={currentUser}
            onCancel={() => setVisibleCheckout(false)}
            amount={preBranch?.clubData.price[duration]}
            currency={preBranch?.clubData.currency}
            booking={{
              club: preBranch?.clubData,
              branch: preBranch,
              bookingDate,
              bookingTime,
              duration
            }}
            onDone={onDonePayment}
          />
        </Paper>
      </Col>
      }
    </Row>

  )
}